import { useState, useEffect } from 'react';
import { getGeolocation } from '../services/apiService';

/**
 * Custom hook to fetch and manage geolocation data
 * Returns country name, full geolocation data, loading and error states
 * Geolocation is MANDATORY for form submission
 */
export const useGeolocation = () => {
  const [geoData, setGeoData] = useState(null);
  const [country, setCountry] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGeolocation = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getGeolocation();
      if (data && data.isSuccess && data.data?.ipAddress) {
        setGeoData(data);
        setCountry(data.data?.countryName || '');
        setError(null);
      } else {
        setError('Failed to detect location');
      }
    } catch (error) {
      console.error('Error fetching geolocation:', error);
      setError('Network error while detecting location');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGeolocation();
  }, []);

  // Retry function for manual retry
  const retry = () => {
    fetchGeolocation();
  };

  return { geoData, country, isLoading, error, retry };
};
